import { cssVar } from '@mfw/common';
import type { ToggleButtonProps } from '@mui/material/ToggleButton';
import type { Theme } from '@mui/material/styles';

import { toggleButtonClasses } from '@mui/material/ToggleButton';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
] as const;

// ----------------------------------------------------------------------

export function toggleButton(theme: Theme) {
  const rootStyles = (ownerState: ToggleButtonProps) => {
    const defaultStyle = {
      [`&.${toggleButtonClasses.selected}`]: {
        borderColor: 'currentColor',
        boxShadow: '0 0 0 0.5px currentColor',
      },
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        '&:hover': {
          backgroundColor: alpha(
            theme.palette[color].main,
            theme.palette.action.hoverOpacity,
          ),
          borderColor: alpha(theme.palette[color].main, 0.48),
        },
      }),
    }));

    const disabledState = {
      [`&.${toggleButtonClasses.disabled}`]: {
        [`&.${toggleButtonClasses.selected}`]: {
          backgroundColor: cssVar.action.selected,
          borderColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        },
      },
    };

    return [defaultStyle, ...colorStyle, disabledState];
  };

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ToggleButtonProps }) =>
          rootStyles(ownerState),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        grouped: {
          '&:not(:first-of-type), &:not(:last-of-type)': {
            borderColor: 'transparent',
            borderRadius: theme.shape.borderRadius,
          },
          [`&.${toggleButtonClasses.selected}`]: {
            boxShadow: 'none',
          },
          margin: 4,
        },
        root: {
          backgroundColor: cssVar.background.paper,
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.08)}`,
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
  };
}
